import Layout from "@/modules/datas/datas-layout"

import Subscriptions from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-list"
import Subscription from "@/modules/datas/subscriptions/subscriptions-components/subscriptions-details"

import Variables from "@/modules/datas/variables/variables-components/variables-list"
import Variable from "@/modules/datas/variables/variables-components/variables-details"

import Areas from "@/modules/datas/areas/areas-components/areas-list"
import Tags from "@/modules/datas/tags/tags-components/tags-list"

const DatasRouter = {
	path: "/datas",
	name: "datas",
	component: Layout,
	children: [
		{
			path: "subscriptions/:subscription_id",
			name: "datas.subscriptions.subscription_id",
			component: Subscription,
			props: true
		},
		{
			path: "subscriptions",
			name: "datas.subscriptions",
			component: Subscriptions,
			props: true
		},
		{
			path: "variables/:variable_id",
			name: "datas.variables.variable_id",
			component: Variable,
			props: true
		},
		{
			path: "variables",
			name: "datas.variables",
			component: Variables,
			props: true
		},
		{
			path: "areas",
			name: "datas.areas",
			component: Areas,
			props: true
		},
		{
			path: "tags",
			name: "datas.tags",
			component: Tags,
			props: true
		},
		{
			path: "",
			name: "datas.subscriptions",
			component: Subscriptions,
			props: true
		}
	]
}

export default DatasRouter
